/* eslint-disable react/prop-types*/
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Box, List, ListItemButton, ListItemText, Paper, Tooltip } from "@mui/material";
import DownArrow from "../asset/table/expand-row/DownArrow";
import UpArrow from "../asset/table/expand-row/UpArrow";

export default function ScanResult(props) {
    const [open, setOpen] = React.useState(true);
    const navigate = useNavigate();
    const iconS = 22;
    const iconSizeStyle = {
        width: iconS,
        minWidth: iconS,
        maxWidth: iconS,
        height: iconS,
        maxHeight: iconS,
        minHeight: iconS,
        marginLeft: 6
    };

    return (
        <Box
            className="scanResult noScroll"
            sx={{
                display: 'flex',
                bottom: 0,
                overflow: "scroll",
                maxHeight: "calc(100vh - 610px)",
                minHeight: "120px",
                background:"transparent",
                borderStyle: "solid",
                borderWidth: "0 1px 1px 1px",
                borderColor: "rgb(59, 59, 59)",
                // background: "linear-gradient(180deg, rgba(191, 196, 192, 0.2) 1.83%, rgba(134, 134, 134, 0.2) 100%)",                    
                // border:"1px solid rgb(59, 59, 59)",

                borderRadius: "0 0 8px 8px",
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    width: "calc(100%)",
                    background: "transparent",
                }}
            >
                <List
                    component="nav"
                    disablePadding
                >
                    <Box
                        className="msscanResult"
                        sx={{
                            minWidth: 10,
                            maxWidth: 10000,
                            pb: open ? 2 : 0,
                        }}
                    >
                        <div
                            onClick={() => setOpen(!open)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                background: "var(--scan-result-header-bg-color)",
                                fontSize: "12px",
                                borderRadius: "0px",
                                padding: "5px 5px 5px 20px",
                                cursor: "pointer"
                            }}
                        >
                            <span style={{color: "var(--scan-result-header-text-color)"}}>
                                IP Address
                            </span>

                            <span style={{color: "var(--scan-result-header-text-color)"}}>
                                Timestamp
                            </span>

                            <span style={{color: "var(--scan-result-header-text-color)"}}>
                                Credential
                            </span>

                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                {(open && props.data.length > 0) ?
                                    <div
                                        className="scan__add-all"
                                        onClick={(e) => {
                                            e.stopPropagation();

                                            props.setValue(p => {
                                                let newP = [...p];

                                                props.data.forEach(element => {
                                                    if (!newP.includes(element)) {
                                                        newP.push(element);
                                                    }
                                                });

                                                return newP;
                                            });
                                        }}
                                    >
                                        Add all
                                    </div>
                                    :
                                    <></>
                                }

                                <div style={{ display: "flex", alignItems: "center", color: "var(--scan-result-header-expand-bg-color)" }}>
                                    {open ? <UpArrow /> : <DownArrow />}
                                </div>
                            </div>
                        </div>

                        {open &&
                            props.data.sort((ina, inb) => {
                                let ret = 0;

                                try {
                                    ret = (props.dataTimes[inb] ? props.dataTimes[inb] : 0)-(props.dataTimes[ina] ? props.dataTimes[ina] : 0);
                                } catch (e) {
                                    console.log(e);
                                }

                                return ret;
                            }).map((item, i) => (
                                <ListItemButton key={"ip" + i}>
                                    <ListItemText
                                        onClick={() => {
                                            props.setValue(p => {
                                                return p.includes(item) ? p : [...p, item];
                                            })
                                        }}
                                        primary={
                                            <div>
                                                <div
                                                    style={{
                                                        display:"flex",
                                                        justifyContent:"space-between",
                                                        minWidth: 200
                                                    }}
                                                >
                                                    <div
                                                        style={{ width: "100%", fontFamily: "InterLight", color: "var(--scan-result-ip-address-text-color)" }}
                                                    >
                                                        {item}
                                                    </div>

                                                    <div
                                                        style={{ width: "100%", display: "flex", justifyContent: "center", fontFamily: "InterLight", color: "var(--scan-result-table-cell-text-color)" }}
                                                    >
                                                        {props.dataTimes ?
                                                            props.dataTimes[item] ?
                                                                props.dataTimes[item].timestamp ?
                                                                    new Intl.DateTimeFormat('en-US', {
                                                                        hour: '2-digit',
                                                                        minute: '2-digit',
                                                                        second: '2-digit',
                                                                        hourCycle: 'h23'
                                                                    }).format(parseInt(props.dataTimes[item].timestamp, 10)): "" : ""
                                                        :
                                                        ""}
                                                    </div>

                                                    <div
                                                        style={{ width: "100%", fontFamily: "InterLight", color: "var(--scan-result-table-cell-text-color)" }}
                                                    >
                                                        {props.dataTimes ?
                                                            props.dataTimes[item] ?
                                                                props.dataTimes[item].protocol ?
                                                                    <>
                                                                        <div
                                                                            className="noScroll"
                                                                            style={{ width: "100%", display: "flex", justifyContent: "center"  }}
                                                                            >
                                                                            {props.dataTimes[item].protocol.split(",").length > 1 ?
                                                                                <Tooltip title={props.dataTimes[item].protocol}>
                                                                                    <div>
                                                                                        <span>
                                                                                            {props.dataTimes[item].protocol.split(",")[0]}
                                                                                        </span>

                                                                                        <div
                                                                                            className="scanBadge"
                                                                                            style={{
                                                                                                transform:"scale(0.6)",
                                                                                                right:-15,
                                                                                                marginTop:-20,
                                                                                                color:"white"
                                                                                            }}
                                                                                        >
                                                                                            {props.dataTimes[item].protocol.split(",").length}
                                                                                        </div>
                                                                                    </div>
                                                                                </Tooltip>
                                                                                :
                                                                                props.dataTimes[item].protocol.split(",")[0]
                                                                            }
                                                                            <>
                                                                            </>
                                                                        </div>
                                                                    </>
                                                                :
                                                                ""
                                                                :
                                                                ""
                                                                :
                                                                ""
                                                            }
                                                        </div>

                                                        <div style={{ width: "100%" }}></div>
                                                    </div>

                                                    <div
                                                        className="itemScanR"
                                                        style={{
                                                            float: "right",                                            
                                                            display: props.systemMap[item] ? "block" : "none",
                                                            paddingLeft: 2,
                                                            paddingRight: 20,
                                                            borderBottom: "0.42px solid rgba(255,255,255,0.2)"
                                                        }}
                                                        onClick={() => {
                                                            if (props.systemMap[item]) {
                                                                navigate(`/discovery/0/${props.systemMap[item].id}`);
                                                            }
                                                        }}
                                                    >
                                                        {props.systemMap[item] ?
                                                            <>
                                                                <div
                                                                    style={{
                                                                        paddingRight: 18,
                                                                        display: "inline-block"
                                                                    }}
                                                                >
                                                                    {props.systemMap[item].hostName}
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        position: "absolute",
                                                                        marginTop: -2,
                                                                        marginLeft: -8,
                                                                        display: "inline-block",
                                                                    }}
                                                                >
                                                                    {props.systemMap[item].cloudType == "AWS" ?
                                                                        <img
                                                                            style={{
                                                                                ...iconSizeStyle,
                                                                                borderRadius: 4,
                                                                                marginTop: 0,
                                                                                zIndex: 2
                                                                            }}
                                                                            src='img/aws.svg'
                                                                        />
                                                                        :
                                                                        <svg width="22" height="22" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <g clipPath="url(#clip0_2251_471)" transform='translate(0,4)'>
                                                                                <path d="M42 4H6C3.8 4 2 5.8 2 8V32C2 34.2 3.8 36 6 36H20V40H16V44H32V40H28V36H42C44.2 36 46 34.2 46 32V8C46 5.8 44.2 4 42 4ZM42 32H6V8H42V32Z" fill="white" />
                                                                            </g>

                                                                            <defs>
                                                                                <clipPath id="clip0_2251_471">
                                                                                    <rect width="48" height="48" fill="white" />
                                                                                </clipPath>
                                                                            </defs>
                                                                        </svg>
                                                                    }
                                                                </div>
                                                            </>
                                                            :
                                                            ""
                                                        }
                                                    </div>
                                                </div>
                                            }
                                            primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium' }}
                                        />
                                    </ListItemButton>
                                )
                            )
                        }
                    </Box>
                </List>
            </Paper>
        </Box>
    );
}
